import { RoutingNode } from 'hooks/useRouteCalculator/routing-graph';

const urnPageRouting: RoutingNode = {
    forwardEdges: [],
    backwardEdges: [],
    forAllForwardEdges: state => state.selectedProducts.filter(products => products.subCategory === 'Urn').length > 0,
};

export default urnPageRouting;
